var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-sample",style:(`
      color: ${_vm.settings.textColor};
      background: ${_vm.settings.backgroundColor};
      line-height: ${_vm.settings.enableLineHeight ? _vm.settings.lineHeight : ''};
      letter-spacing: ${_vm.settings.enableTracking ? _vm.settings.tracking : '0'}em;
      word-spacing: ${_vm.settings.enableWordSpacing ? _vm.settings.wordSpacing : '0'}em;
      text-align: ${_vm.settings.textAlign};
      text-transform: ${_vm.settings.enableTextTransform ? _vm.settings.textTransform : 'none'};
      font-feature-settings: ${ _vm.fontFeatureSettings };
      font-variation-settings: ${ _vm.fontVariationSettings };
      font-weight: ${ _vm.fontWeight };
      --font-weight: ${ _vm.fontWeight };
      font-style: ${ _vm.fontStyle };
  `)},[_c('div',{staticClass:"font-sample-content",style:({
      'word-break': _vm.settings.wrapLines ? 'break-all' : 'normal',
    })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }